const TIME_WITH_OPTIONAL_SECONDS = /^(\d{1,2}):(\d{2})(?::(\d{2}))?$/;

const padTimeSegment = (value) => String(value).padStart(2, "0");

export function secondsToTimeInput(value) {
  const totalSeconds = Number(value);
  if (!Number.isFinite(totalSeconds) || totalSeconds < 0) return "";

  const hours = Math.floor(totalSeconds / 3600);
  const minutes = Math.floor((totalSeconds % 3600) / 60);
  return `${padTimeSegment(hours)}:${padTimeSegment(minutes)}`;
}

export function normalizeApiTimeToInput(value) {
  if (value === null || value === undefined || value === "") return "";

  if (typeof value === "number") {
    return secondsToTimeInput(value);
  }

  if (typeof value === "string") {
    const trimmed = value.trim();
    if (!trimmed) return "";

    if (/^\d+$/.test(trimmed)) {
      return secondsToTimeInput(Number(trimmed));
    }

    const match = trimmed.match(TIME_WITH_OPTIONAL_SECONDS);
    if (!match) return "";

    const [, rawHours, rawMinutes, rawSeconds = "00"] = match;
    const hours = Number(rawHours);
    const minutes = Number(rawMinutes);
    const seconds = Number(rawSeconds);

    if (
      !Number.isInteger(hours) ||
      !Number.isInteger(minutes) ||
      !Number.isInteger(seconds) ||
      hours < 0 ||
      hours > 23 ||
      minutes < 0 ||
      minutes > 59 ||
      seconds < 0 ||
      seconds > 59
    ) {
      return "";
    }

    return `${padTimeSegment(hours)}:${padTimeSegment(minutes)}`;
  }

  return "";
}

export function sanitizeTimeForApi(value) {
  const normalized = normalizeApiTimeToInput(value);
  return normalized || null;
}
